// License / upgrade gate handlers shared by the RPC facades (agent ops,
// invitations, billing). Extracted from app.svelte.ts (knowledge/87) so sibling
// facade modules import them DOWN here instead of cycling back through the
// app.svelte.ts barrel. Plain .ts — it only mutates the imported `licenseState`
// proxy (declared in license.svelte.ts), which stays reactive across modules.
import { LicenseRequiredError, UpgradeRequiredError } from "../core/client.js";
import { licenseState } from "./license.svelte.js";

// HARD-PAUSE gate handler for RPC-based agent ops (create / spawn / prompt).
// The relay rejects these with a LicenseRequiredError once the trial ends with
// no active sub. Re-seed the license + open the activate modal; returns true if
// it handled a license error so the caller can decide whether to re-throw.
export function handleLicenseError(err: unknown): boolean {
  if (err instanceof LicenseRequiredError) {
    if (err.license) licenseState.set(err.license);
    licenseState.openModal();
    return true;
  }
  return false;
}

// Pricing v2 upgrade gate for RPC-based ops. The relay rejects a Free workspace's
// Pro-only action (pro_required) or a 6th-member invite (seat_limit_reached) with
// an UpgradeRequiredError. Sibling to handleLicenseError: preserve the server copy
// and open the (upgrade) modal; returns true if it handled an upgrade error so the
// caller can decide whether to re-throw. Distinct from the paused-trial paywall.
export function handleUpgradeError(err: unknown): boolean {
  if (err instanceof UpgradeRequiredError) {
    licenseState.setUpgradeMessage(err.message);
    licenseState.openModal();
    return true;
  }
  return false;
}
